import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin } from 'antd';

import AdditionalDetailsForms from '../../forms/AdditionalDetailsForms';

import QUERY from '../../graphql/queries/getFactsheetAdditionalDetailsQuery.graphql';

const AdditionalDetails = (props) => {
  const { loading, customerAdditionalDetails } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  return (
    <AdditionalDetailsForms customerAdditionalDetails={customerAdditionalDetails} customer_id={props.match.params.id} />
  );
};

AdditionalDetails.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerAdditionalDetails: PropTypes.shape({
      company_background: PropTypes.string,
      promoters_background: PropTypes.string,
      project_background: PropTypes.string,
      ecosystem_brief: PropTypes.string,
      remarks: PropTypes.string,
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default graphql(QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(AdditionalDetails);



// WEBPACK FOOTER //
// ./src/pages/factsheet/AdditionalDetails.jsx